import { render, staticRenderFns } from "./chartDataAge.vue?vue&type=template&id=94f8d3c2&scoped=true&"
import script from "./chartDataAge.vue?vue&type=script&lang=js&"
export * from "./chartDataAge.vue?vue&type=script&lang=js&"
import style0 from "./chartDataAge.vue?vue&type=style&index=0&id=94f8d3c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f8d3c2",
  null
  
)

export default component.exports